function parseDoi(data) {
  const list = Array.isArray(data) ? data : data.trim().split(/(?:\s+)/g);
  return list.map(doi => `https://doi.org/${doi}`);
}
export { parseDoi as parse, parseDoi as default };